import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Check2 = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg viewBox="0 0 19.241 18.481" width={size} height={size} color={iconColor}>
      <title>{iconTitle}</title>
      <g data-name="Layer 2">
        <path
          fill={iconColor}
          d="M0 7.428l9.136 11.053L19.241 0 8.717 13.991 0 7.428z"
          data-name="Layer 1"
        />
      </g>
    </svg>
  );
};

Check2.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Check2.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};
export default withTheme(Check2);
